import React, { useEffect, useState, createElement, Component } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
export const ConsultationForm = () => {
  // State declarations would go here
  const [formData, setFormData] = useState({
    wru: '',
    reference: '',
    name: '',
    fgname: '',
    age: '',
    gender: '',
    email: '',
    address: '',
    city: '',
    pin: '',
    whatsapp: '',
    thirst: '',
    appetite: '',
    foodHabits: {
      fruits: false,
      healthyFood: false,
      noWaterBeforeAfter: false,
      waterBeforeAfter: false
    },
    sleep: '',
    dreams: '',
    hygiene: '',
    addiction: '',
    lifestyle: {
      active: false,
      healthy: false,
      urban: false,
      rural: false,
      bohemian: false,
      minimalist: false,
      sustainable: false
    },
    body: '',
    temperature: '',
    mentalcondition: '',
    bp: '',
    pulse: '',
    addPulseDetails: '',
    pulseDetails: {
      leftCun: '',
      leftGuan: '',
      leftChi: '',
      rightCun: '',
      rightGuan: '',
      rightChi: ''
    },
    bowel: '',
    urineFrequencyDay: '',
    urineFrequencyNight: '',
    urineColor: '',
    urineSmell: '',
    skin: '',
    shair: '',
    bhair: '',
    nails: '',
    bodyOdor: '',
    mouthOdor: '',
    throat: '',
    oedma: '',
    eyes: '',
    ears: '',
    lips: '',
    medicalHistory: {
      diabetic: false,
      preDiabetic: false,
      heartProblem: false,
      kidneyProblem: false,
      highBloodPressure: false,
      arthritis: false,
      cancer: false,
      hivAids: false,
      hepatitis: false,
      stroke: false,
      paralysis: false,
      alzheimers: false,
      asthma: false,
      organTransplant: false
    },
    mensturation: '',
    cdays: '',
    painful: {
      noPain: false,
      before: false,
      during: false,
      after: false
    },
    clots: '',
    flowType: '',
    isPregnant: '',
    pregnancyMonth: '',
    isMenopause: '',
    gynecologicalConditions: {
      cancers: false,
      endometriosis: false,
      pcos: false,
      dysmenorrhea: false,
      amenorrhea: false,
      menorrhagia: false,
      pms: false,
      adenomyosis: false,
      utis: false,
      anemia: false,
      infertility: false,
      fibroidsCysts: false
    },
    ccomplaint: '',
    presentill: '',
    pastill: '',
    fhistory: ''
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionError, setSubmissionError] = useState('');
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [showConsentPopup, setShowConsentPopup] = useState(false);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [tongueImages, setTongueImages] = useState([]);
  const [reportFiles, setReportFiles] = useState([]);
  const isFemale = formData.gender === 'Female';
  // Helper function to remove Hindi text from strings
  const removeHindi = text => {
    if (!text) return text;
    // Remove content within parentheses that contains Hindi characters
    return text.replace(/\([^)]*[\u0900-\u097F][^)]*\)/g, '').trim();
  };
  // Event handlers
  const handleChange = e => {
    const {
      id,
      value
    } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [id]: value
    }));
  };
  const handleFoodHabitsChange = e => {
    const {
      name,
      checked
    } = e.target;
    setFormData(prevData => ({
      ...prevData,
      foodHabits: {
        ...prevData.foodHabits,
        [name]: checked
      }
    }));
  };
  const handleLifestyleChange = e => {
    const {
      name,
      checked
    } = e.target;
    setFormData(prevData => ({
      ...prevData,
      lifestyle: {
        ...prevData.lifestyle,
        [name]: checked
      }
    }));
  };
  const handlePainfulChange = e => {
    const {
      name,
      checked
    } = e.target;
    setFormData(prevData => ({
      ...prevData,
      painful: {
        ...prevData.painful,
        [name]: checked
      }
    }));
  };
  const handlePulseDetailsChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prevData => ({
      ...prevData,
      pulseDetails: {
        ...prevData.pulseDetails,
        [name]: value
      }
    }));
  };
  const handleMedicalHistoryChange = e => {
    const {
      name,
      checked
    } = e.target;
    setFormData(prevData => ({
      ...prevData,
      medicalHistory: {
        ...prevData.medicalHistory,
        [name]: checked
      }
    }));
  };
  const handleGynecologicalConditionsChange = e => {
    const {
      name,
      checked
    } = e.target;
    setFormData(prevData => ({
      ...prevData,
      gynecologicalConditions: {
        ...prevData.gynecologicalConditions,
        [name]: checked
      }
    }));
  };
  const handleTongueImageUpload = e => {
    const files = Array.from(e.target.files);
    if (tongueImages.length + files.length > 10) {
      setSubmissionError('You can upload a maximum of 10 tongue images.');
      return;
    }
    const newImages = files.map(file => ({
      file,
      preview: URL.createObjectURL(file),
      name: file.name
    }));
    setTongueImages(prev => [...prev, ...newImages]);
    setSubmissionError('');
  };
  const handleReportFileUpload = e => {
    const files = Array.from(e.target.files);
    if (reportFiles.length + files.length > 10) {
      setSubmissionError('You can upload a maximum of 10 report files.');
      return;
    }
    const newFiles = files.map(file => ({
      file,
      name: file.name,
      type: file.type,
      size: (file.size / 1024 / 1024).toFixed(2) // Size in MB
    }));
    setReportFiles(prev => [...prev, ...newFiles]);
    setSubmissionError('');
  };
  const removeTongueImage = index => {
    setTongueImages(prev => {
      const updated = [...prev];
      URL.revokeObjectURL(updated[index].preview);
      updated.splice(index, 1);
      return updated;
    });
  };
  const removeReportFile = index => {
    setReportFiles(prev => {
      const updated = [...prev];
      updated.splice(index, 1);
      return updated;
    });
  };
  const handleSubmit = async e => {
    e.preventDefault();
    if (!agreedToTerms) {
      setSubmissionError('Please read and agree to the informed consent before submitting.');
      return;
    }
    // Generate PDF on submit
    await handleDownloadPDF();
    setFormSubmitted(true);
  };
  const handleDownloadPDF = async () => {
    setIsGeneratingPDF(true);
    try {
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 20;
      const contentWidth = pageWidth - 2 * margin;
      let yPosition = margin;
      // Helper functions remain the same...
      const checkPageBreak = requiredSpace => {
        if (yPosition + requiredSpace > pageHeight - margin) {
          pdf.addPage();
          yPosition = margin;
          return true;
        }
        return false;
      };
      const addSectionHeader = title => {
        checkPageBreak(15);
        pdf.setFillColor(239, 246, 255);
        pdf.rect(margin, yPosition, contentWidth, 10, 'F');
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(12);
        pdf.setTextColor(30, 64, 175);
        pdf.text(removeHindi(title), margin + 3, yPosition + 7);
        yPosition += 12;
      };
      const addField = (label, value) => {
        checkPageBreak(8);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(10);
        pdf.setTextColor(0, 0, 0);
        pdf.text(removeHindi(label) + ':', margin + 3, yPosition);
        pdf.setFont('helvetica', 'normal');
        const cleanValue = removeHindi(value || 'N/A');
        const lines = pdf.splitTextToSize(cleanValue, contentWidth - 50);
        pdf.text(lines, margin + 50, yPosition);
        yPosition += lines.length * 5 + 3;
      };
      // Add header with logo
      try {
        const logoImg = await fetch('https://cdn.magicpatterns.com/uploads/qBE9HyDyREi7QAMprS1Hx8/image.png');
        const logoBlob = await logoImg.blob();
        const logoDataUrl = await new Promise(resolve => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(logoBlob);
        });
        pdf.addImage(logoDataUrl, 'PNG', margin, yPosition, contentWidth, 30);
        yPosition += 35;
      } catch (error) {
        console.error('Error loading logo:', error);
        yPosition += 10;
      }
      // Title
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(16);
      pdf.setTextColor(30, 64, 175);
      pdf.text('Online Treatment / Consultation Form', pageWidth / 2, yPosition, {
        align: 'center'
      });
      yPosition += 15;
      // Basic Information
      addSectionHeader('Basic Information');
      addField('Are You', formData.wru);
      addField('Reference', formData.reference);
      yPosition += 5;
      // Personal Information
      addSectionHeader('Personal Information');
      addField('Name', formData.name);
      addField('Father/Guardian', formData.fgname);
      addField('Age', formData.age);
      addField('Gender', formData.gender);
      addField('Email', formData.email);
      addField('Address', formData.address);
      addField('City', formData.city);
      addField('Pin Code', formData.pin);
      addField('WhatsApp', formData.whatsapp);
      yPosition += 5;
      // Health & Lifestyle
      addSectionHeader('Health & Lifestyle');
      addField('Thirst', formData.thirst);
      addField('Appetite', formData.appetite);
      addField('Food Habits', [formData.foodHabits.fruits && 'Takes Fruits and Dry fruits', formData.foodHabits.healthyFood && 'Takes 3 Times Healthy Food', formData.foodHabits.noWaterBeforeAfter && 'No water before/after meals', formData.foodHabits.waterBeforeAfter && 'Takes water before/after meals'].filter(Boolean).join(', '));
      addField('Sleep', formData.sleep);
      addField('Dreams', formData.dreams);
      addField('Personal Hygiene', formData.hygiene);
      addField('Addiction', formData.addiction);
      addField('Lifestyle', [formData.lifestyle.active && 'Active', formData.lifestyle.healthy && 'Healthy', formData.lifestyle.urban && 'Urban', formData.lifestyle.rural && 'Rural', formData.lifestyle.bohemian && 'Bohemian', formData.lifestyle.minimalist && 'Minimalist', formData.lifestyle.sustainable && 'Sustainable'].filter(Boolean).join(', '));
      yPosition += 5;
      // Medical History
      addSectionHeader('Medical History');
      addField('Disease History', [formData.medicalHistory.diabetic && 'Diabetic', formData.medicalHistory.preDiabetic && 'Pre-Diabetic', formData.medicalHistory.heartProblem && 'Heart Related Problem', formData.medicalHistory.kidneyProblem && 'Kidney Related Problem', formData.medicalHistory.highBloodPressure && 'High Blood Pressure', formData.medicalHistory.arthritis && 'Arthritis', formData.medicalHistory.cancer && 'Cancer', formData.medicalHistory.hivAids && 'HIV/AIDS', formData.medicalHistory.hepatitis && 'Hepatitis', formData.medicalHistory.stroke && 'Stroke', formData.medicalHistory.paralysis && 'Paralysis', formData.medicalHistory.alzheimers && "Alzheimer's Disease", formData.medicalHistory.asthma && 'Asthma', formData.medicalHistory.organTransplant && 'Any Organ Transplant'].filter(Boolean).join(', '));
      yPosition += 5;
      // Physical Attributes
      addSectionHeader('Physical Attributes');
      addField('Body Type', formData.body);
      addField('Temperature', formData.temperature);
      addField('Mental Condition', formData.mentalcondition);
      addField('Blood Pressure', formData.bp);
      addField('Pulse rate', formData.pulse);
      yPosition += 5;
      // Pulse Details (WITHOUT diagram) - IMPROVED FORMATTING
      if (formData.addPulseDetails === 'Yes') {
        addSectionHeader('Pulse Diagnosis Details');
        // Add each pulse detail on its own line with proper spacing
        if (formData.pulseDetails.leftCun) {
          checkPageBreak(8);
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(10);
          pdf.setTextColor(0, 0, 0);
          pdf.text('Left Cun - Heart/Small Intestine:', margin + 3, yPosition);
          pdf.setFont('helvetica', 'normal');
          const lines = pdf.splitTextToSize(removeHindi(formData.pulseDetails.leftCun || 'N/A'), contentWidth - 80);
          pdf.text(lines, margin + 80, yPosition);
          yPosition += Math.max(lines.length * 5, 7);
        }
        if (formData.pulseDetails.leftGuan) {
          checkPageBreak(8);
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(10);
          pdf.text('Left Guan - Liver/Gallbladder:', margin + 3, yPosition);
          pdf.setFont('helvetica', 'normal');
          const lines = pdf.splitTextToSize(removeHindi(formData.pulseDetails.leftGuan || 'N/A'), contentWidth - 80);
          pdf.text(lines, margin + 80, yPosition);
          yPosition += Math.max(lines.length * 5, 7);
        }
        if (formData.pulseDetails.leftChi) {
          checkPageBreak(8);
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(10);
          pdf.text('Left Chi - Kidney Yin:', margin + 3, yPosition);
          pdf.setFont('helvetica', 'normal');
          const lines = pdf.splitTextToSize(removeHindi(formData.pulseDetails.leftChi || 'N/A'), contentWidth - 80);
          pdf.text(lines, margin + 80, yPosition);
          yPosition += Math.max(lines.length * 5, 7);
        }
        if (formData.pulseDetails.rightCun) {
          checkPageBreak(8);
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(10);
          pdf.text('Right Cun - Lung/Large Intestine:', margin + 3, yPosition);
          pdf.setFont('helvetica', 'normal');
          const lines = pdf.splitTextToSize(removeHindi(formData.pulseDetails.rightCun || 'N/A'), contentWidth - 80);
          pdf.text(lines, margin + 80, yPosition);
          yPosition += Math.max(lines.length * 5, 7);
        }
        if (formData.pulseDetails.rightGuan) {
          checkPageBreak(8);
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(10);
          pdf.text('Right Guan - Spleen/Stomach:', margin + 3, yPosition);
          pdf.setFont('helvetica', 'normal');
          const lines = pdf.splitTextToSize(removeHindi(formData.pulseDetails.rightGuan || 'N/A'), contentWidth - 80);
          pdf.text(lines, margin + 80, yPosition);
          yPosition += Math.max(lines.length * 5, 7);
        }
        if (formData.pulseDetails.rightChi) {
          checkPageBreak(8);
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(10);
          pdf.text('Right Chi - Kidney Yang:', margin + 3, yPosition);
          pdf.setFont('helvetica', 'normal');
          const lines = pdf.splitTextToSize(removeHindi(formData.pulseDetails.rightChi || 'N/A'), contentWidth - 80);
          pdf.text(lines, margin + 80, yPosition);
          yPosition += Math.max(lines.length * 5, 7);
        }
        yPosition += 5;
      }
      // Bodily Functions
      addSectionHeader('Bodily Functions');
      addField('Bowel Movement', formData.bowel);
      addField('Urine Frequency Day', formData.urineFrequencyDay);
      addField('Urine Frequency Night', formData.urineFrequencyNight);
      addField('Urine Color', formData.urineColor);
      addField('Urine Smell', formData.urineSmell);
      yPosition += 5;
      addSectionHeader('Physical Appearance');
      addField('Skin', formData.skin);
      addField('Scalp Hair', formData.shair);
      addField('Body Hair', formData.bhair);
      addField('Nails', formData.nails);
      yPosition += 5;
      addSectionHeader('Body & Mouth Odor');
      addField('Body Odor', formData.bodyOdor);
      addField('Mouth Odor', formData.mouthOdor);
      yPosition += 5;
      addSectionHeader('Body Parts');
      addField('Throat', formData.throat);
      addField('Edema', formData.oedma);
      addField('Eyes', formData.eyes);
      addField('Ears', formData.ears);
      addField('Lips', formData.lips);
      yPosition += 5;
      // Female-specific
      if (formData.gender === 'Female') {
        addSectionHeader('Female-specific Information');
        addField('Pregnant', formData.isPregnant);
        if (formData.isPregnant === 'Yes') {
          addField('Pregnancy Month', formData.pregnancyMonth);
        }
        addField('Menopause', formData.isMenopause);
        addField('Mensturation Duration', formData.mensturation);
        addField('Cycle days', formData.cdays);
        addField('Painful', [formData.painful.noPain && 'No Pain', formData.painful.before && 'Before', formData.painful.during && 'During', formData.painful.after && 'After'].filter(Boolean).join(', '));
        addField('Clots', formData.clots);
        addField('Flow Type', formData.flowType);
        addField('Gynecological Conditions', [formData.gynecologicalConditions.cancers && 'Cancers', formData.gynecologicalConditions.endometriosis && 'Endometriosis', formData.gynecologicalConditions.pcos && 'PCOS', formData.gynecologicalConditions.dysmenorrhea && 'Dysmenorrhea', formData.gynecologicalConditions.amenorrhea && 'Amenorrhea', formData.gynecologicalConditions.menorrhagia && 'Menorrhagia', formData.gynecologicalConditions.pms && 'PMS', formData.gynecologicalConditions.adenomyosis && 'Adenomyosis', formData.gynecologicalConditions.utis && 'UTIs', formData.gynecologicalConditions.anemia && 'Anemia', formData.gynecologicalConditions.infertility && 'Infertility', formData.gynecologicalConditions.fibroidsCysts && 'Fibroids/Cysts'].filter(Boolean).join(', '));
        yPosition += 5;
      }
      addSectionHeader('Complaint & Illness Information');
      addField('Chief Complaint', formData.ccomplaint);
      addField('Present Illness', formData.presentill);
      addField('Past Illness', formData.pastill);
      addField('Family History', formData.fhistory);
      yPosition += 5;
      // Add tongue images
      if (tongueImages.length > 0) {
        pdf.addPage();
        yPosition = margin;
        addSectionHeader('Tongue Images');
        for (let i = 0; i < tongueImages.length; i++) {
          try {
            const img = tongueImages[i];
            const imgDataUrl = await new Promise(resolve => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.readAsDataURL(img.file);
            });
            // Create an image element to get original dimensions
            const imgElement = new Image();
            await new Promise(resolve => {
              imgElement.onload = resolve;
              imgElement.src = imgDataUrl;
            });
            // Add new page for each image
            if (i > 0) {
              pdf.addPage();
              yPosition = margin;
            }
            // Calculate dimensions to fill the page while maintaining aspect ratio
            const availableWidth = pageWidth - 2 * margin;
            const availableHeight = pageHeight - 2 * margin - 15; // Reserve space for label
            let imgWidth = imgElement.width;
            let imgHeight = imgElement.height;
            const aspectRatio = imgWidth / imgHeight;
            // Scale to fit available space
            if (availableWidth / availableHeight > aspectRatio) {
              // Height is the limiting factor
              imgHeight = availableHeight;
              imgWidth = availableHeight * aspectRatio;
            } else {
              // Width is the limiting factor
              imgWidth = availableWidth;
              imgHeight = availableWidth / aspectRatio;
            }
            // Convert pixels to mm (assuming 96 DPI)
            const widthMm = imgWidth * 25.4 / 96;
            const heightMm = imgHeight * 25.4 / 96;
            // Center the image on the page
            const xPosition = (pageWidth - widthMm) / 2;
            const yImagePosition = yPosition + 10;
            pdf.setFont('helvetica', 'normal');
            pdf.setFontSize(10);
            pdf.text(`Tongue Image ${i + 1}: ${img.name}`, margin, yPosition + 5);
            pdf.addImage(imgDataUrl, 'JPEG', xPosition, yImagePosition, widthMm, heightMm);
          } catch (error) {
            console.error('Error adding tongue image:', error);
          }
        }
      }
      // Add report files (images embedded, PDFs as clickable links)
      if (reportFiles.length > 0) {
        pdf.addPage();
        yPosition = margin;
        addSectionHeader('Medical Reports');
        let isFirstReport = true;
        for (let i = 0; i < reportFiles.length; i++) {
          try {
            const file = reportFiles[i];
            // If it's an image, embed it
            if (file.type.startsWith('image/')) {
              const imgDataUrl = await new Promise(resolve => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.readAsDataURL(file.file);
              });
              // Create an image element to get original dimensions
              const imgElement = new Image();
              await new Promise(resolve => {
                imgElement.onload = resolve;
                imgElement.src = imgDataUrl;
              });
              // Add new page for each image (except first one which uses the header page)
              if (!isFirstReport) {
                pdf.addPage();
                yPosition = margin;
              }
              isFirstReport = false;
              // Calculate dimensions to fill the page while maintaining aspect ratio
              const availableWidth = pageWidth - 2 * margin;
              const availableHeight = pageHeight - 2 * margin - 15; // Reserve space for label
              let imgWidth = imgElement.width;
              let imgHeight = imgElement.height;
              const aspectRatio = imgWidth / imgHeight;
              // Scale to fit available space
              if (availableWidth / availableHeight > aspectRatio) {
                // Height is the limiting factor
                imgHeight = availableHeight;
                imgWidth = availableHeight * aspectRatio;
              } else {
                // Width is the limiting factor
                imgWidth = availableWidth;
                imgHeight = availableWidth / aspectRatio;
              }
              // Convert pixels to mm (assuming 96 DPI)
              const widthMm = imgWidth * 25.4 / 96;
              const heightMm = imgHeight * 25.4 / 96;
              // Center the image on the page
              const xPosition = (pageWidth - widthMm) / 2;
              const yImagePosition = yPosition + 10;
              pdf.setFont('helvetica', 'normal');
              pdf.setFontSize(10);
              pdf.text(`Medical Report ${i + 1}: ${file.name}`, margin, yPosition + 5);
              pdf.addImage(imgDataUrl, 'JPEG', xPosition, yImagePosition, widthMm, heightMm);
            } else if (file.type === 'application/pdf') {
              // For PDF files, create clickable link text
              if (!isFirstReport) {
                checkPageBreak(8);
              }
              isFirstReport = false;
              pdf.setFont('helvetica', 'normal');
              pdf.setFontSize(10);
              pdf.setTextColor(30, 64, 175); // Blue color for links
              const linkText = `${i + 1}. ${file.name} (${file.size} MB) - Click to open PDF report`;
              // Create a data URL for the PDF file
              const pdfDataUrl = await new Promise(resolve => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.readAsDataURL(file.file);
              });
              // Add clickable link with the PDF data URL
              pdf.textWithLink(linkText, margin + 3, yPosition, {
                url: pdfDataUrl
              });
              pdf.setTextColor(0, 0, 0); // Reset to black
              yPosition += 6;
            }
          } catch (error) {
            console.error('Error adding report file:', error);
          }
        }
      }
      // Footer
      checkPageBreak(15);
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(9);
      pdf.setTextColor(107, 114, 128);
      pdf.text('Aatmshakti Institute of Integrated Medical Research (AIIMR)', pageWidth / 2, yPosition, {
        align: 'center'
      });
      yPosition += 5;
      pdf.text(`Generated on: ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`, pageWidth / 2, yPosition, {
        align: 'center'
      });
      // Save PDF
      const patientName = formData.name ? formData.name.replace(/\s+/g, '_') : 'Patient';
      const dateStr = new Date().toISOString().split('T')[0];
      pdf.save(`${patientName}_${dateStr}.pdf`);
      setIsGeneratingPDF(false);
    } catch (error) {
      console.error('Error generating PDF:', error);
      setSubmissionError('There was an error generating the PDF. Please try again.');
      setIsGeneratingPDF(false);
    }
  };
  // Consent popup component
  const ConsentPopup = () => {
    if (!showConsentPopup) return null;
    return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-9">
        <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto" data-id="element-10">
          <div className="sticky top-0 bg-blue-800 text-white px-6 py-4 rounded-t-lg flex justify-between items-center" data-id="element-11">
            <h3 className="text-xl font-bold" data-id="element-12">Informed Consent Form</h3>
            <button onClick={() => setShowConsentPopup(false)} className="text-white hover:text-gray-200 focus:outline-none" data-id="element-13">
              <span className="text-2xl" data-id="element-14">&times;</span>
            </button>
          </div>
          <div className="p-6" data-id="element-15">
            <h2 className="text-xl font-bold mb-4 text-center" data-id="element-16">
              Informed Consent Form
            </h2>
            <h3 className="text-lg font-semibold mb-3 text-center" data-id="element-17">
              (For Acupuncture Treatment)
            </h3>
            <p className="mb-4" data-id="element-18">
              Please read this document carefully and completely. This is an
              informed consent that explains the expectations and risks
              associated with Acupuncture Treatment.
            </p>
            <ol className="list-decimal pl-5 space-y-4" data-id="element-19">
              <li data-id="element-20">
                I understand that the professional practitioners
                (acupuncturists) in Aatmshakti Institute of Integrated Medical
                Research(AIIMR) will treat my conditions within their scope of
                practice of Traditional Chinese Medicine (TCM)/ Master Tung's
                Acupuncture / Auricular Medicine with seeds and Acupuncture /
                Dr. Tan Balance Acupuncture Method / Acupressure Therapy /
                Colour Therapy / Korean Cosmetic Acupuncture / Abdominal
                Acupuncture Scalp Acupuncture Neval Acupuncture/ Static Cupping
                /Moving Cupping / Fire Cupping / Blood Letting, which may limit
                treatment choices.
              </li>
              <li data-id="element-21">
                I understand that "Acupuncture" treatment involves the
                penetration of skin by sterile, one-time-use, disposable
                filiform needles. There are additional methods of treatment,
                within the scope of acupuncture and "Traditional Chinese
                Medicine" that may be used in addition to, instead, or in
                combination with needles. The scope includes:
                <ol className="list-decimal pl-5 mt-2 space-y-1" data-id="element-22">
                  <li data-id="element-23">
                    Assessment by the collection of data by interviewing,
                    observation, palpation, pulse taking, tongue observation and
                    other methods;
                  </li>
                  <li data-id="element-24">
                    Acupressure and therapeutic massage (Tui-Na, (Chinese
                    massage));
                  </li>
                  <li data-id="element-25">
                    Dietary herbal supplements and Chinese or Western herbal
                    medicine;
                  </li>
                  <li data-id="element-26">Nutritional counseling;</li>
                  <li data-id="element-27">
                    Energy-flow work, exercises or other prescribed forms of
                    movement (e.g. Qigong, Tai Chi);
                  </li>
                  <li data-id="element-28">
                    Heat therapy with the use of mugwort (moxibustion) or a heat
                    lamp over localized areas;
                  </li>
                  <li data-id="element-29">Glass cups "fire- cupping", plastic suction cups;</li>
                  <li data-id="element-30">Gua Sha tools for scraping;</li>
                  <li data-id="element-31">Electrical stimulation of acupuncture needles</li>
                  <li data-id="element-32">LED (Light therapy)</li>
                </ol>
              </li>
              <li data-id="element-33">
                I understand that as the patient, I must inform the
                practitioners of medications, medical history, and sensitivities
                to smoke or scents, if I am currently pregnant, have a bleeding
                disorder or any communicable or contagious conditions that could
                be passed to others.
              </li>
              <li data-id="element-34">
                I understand that I must lie still during treatment; am
                responsible to ask questions regarding treatment details if
                explanations provided are not clear or understood; have a right
                to refuse treatment at any point.
              </li>
              <li data-id="element-35">
                I understand that patients are advised to tell their doctor they
                are receiving TCM acupuncture, to avoid possible treatment
                conflicts. Patients are encouraged to report their outcomes to
                their doctors.
              </li>
              <li data-id="element-36">
                I understand that the assessment, diagnosis, and treatment of
                medical conditions by TCM varies from Western medicine.
              </li>
              <li data-id="element-37">
                I understand that I must give the clinic 24 hours' notice of
                cancellation otherwise I may be charged the full session fee.
              </li>
              <li data-id="element-38">
                I understand that acupuncture does not typically provide an
                instant cure. For most serious or chronic ailments, more than
                one treatment, along with some lifestyle and dietary changes,
                may be necessary for noticeable changes to take place.
              </li>
            </ol>
            <h3 className="text-lg font-semibold mt-6 mb-3" data-id="element-39">
              Risks and Complications of Acupuncture Treatment
            </h3>
            <p className="mb-4" data-id="element-40">
              I understand that there is risk of side effects, which may
              include:
            </p>
            <div className="space-y-3" data-id="element-41">
              <p data-id="element-42">
                <strong data-id="element-43">Pain</strong> - Acupuncture needling may cause an
                initial "prick" as it punctures the skin followed by a temporary
                achy sensation, numbness, or tingling at or near the needling
                sites that may radiate. These are all normal needling sensations
                and may last a few days. Please tell your practitioner if any
                sensation is too strong so they can adjust the treatment
                accordingly.
              </p>
              <p data-id="element-44">
                Tui-Na (Chinese Massage), acupuncture insertion, acupuncture
                stimulation, electro-acupuncture, cupping, Gua Sha, qigong
                (exercise), may all cause pain. Patient feedback is important
                for the practitioner to adjust the treatment when necessary;
                Electrical stimulation of acupuncture needles produces a mild
                vibration/tapping sensation on the needles, which may be
                painful;
              </p>
              <p data-id="element-45">
                <strong data-id="element-46">Bruising</strong> - Bruising may occur anytime we
                puncture the skin. If you have bruises on some area of the body,
                please inform your practitioner. The normal reaction of cupping,
                "gua sha" and scraping is to leave red marks or bruising. This
                will usually slowly resolve on it's own with 5-10 days and is
                part of the intentional therapeutic effect.
              </p>
              <p data-id="element-47">
                <strong data-id="element-48">Infection</strong> - It is possible to develop an
                infection whenever the skin is punctured despite using single
                use disposable needles and clean needle technique. Please inform
                us if you have a known immune problem so we can take special
                precautions.
              </p>
              <p data-id="element-49">
                <strong data-id="element-50">Burns & Smoke Irritation</strong> - Heat therapy and
                moxibustion may cause redness, blistering or unintentional burns
                and/or scarring. It is important to verbally communicate with
                your practitioner if any heat therapy feels too hot. Smoke from
                moxibustion may cause coughing, lung irritation, headaches or
                allergic reactions for those sensitive to scents or smoke;
              </p>
              <p data-id="element-51">
                <strong data-id="element-52">Feeling of Relaxed or Sleepy</strong> - It is common to
                feel relaxed or sleepy after treatment so avoid getting up too
                quickly and rushing anywhere directly after treatment. Give
                yourself time to adjust after treatment before driving or using
                the stairs or any other potentially dangerous activity.
              </p>
              <p data-id="element-53">
                <strong data-id="element-54">Dizziness & Fainting</strong> - Dizziness or fainting
                can occur as a result of treatment. Please tell us if you are
                prone to fainting. Important factors that can decrease this risk
                include ensuring you have had sufficient food, ensuring you have
                not had any drugs or alcohol prior to treatment, communicating
                if the stimulation is uncomfortably strong, and getting up
                slowly after treatment.
              </p>
              <p data-id="element-55">
                <strong data-id="element-56">Dizziness & Fainting</strong> - Dizziness or fainting
                can occur as a result of treatment. Please tell us if you are
                prone to fainting. Important factors that can decrease this risk
                include ensuring you have had sufficient food, ensuring you have
                not had any drugs or alcohol prior to treatment, communicating
                if the stimulation is uncomfortably strong, and getting up
                slowly after treatment.
              </p>
            </div>
            <h3 className="text-lg font-semibold mt-6 mb-3" data-id="element-57">
              Revoking consent
            </h3>
            <p className="mb-4" data-id="element-58">
              I understand that this initial consent is to educate and explain
              my treatment and that I may verbally revoke my consent to any
              treatment at any time.
            </p>
            <p className="mb-4" data-id="element-59">
              I therefore agree to waive any rights for legal liability that I
              could have against "Aatmshakti Institute of Integrated Medical
              Research" and/or the acupuncture therapist.
            </p>
            <p className="mb-4" data-id="element-60">
              I hereby request and give consent for treatment at the "Aatmshakti
              Institute of Integrated Medical Research" using modalities within
              the scope of "Acupuncture" and "Traditional Chinese Medicine" as
              described above.
            </p>
            <p className="font-semibold" data-id="element-61">
              By Agreeing / signing below, I confirm I have read, understood,
              asked questions and agree to the above Terms of Treatment.
            </p>
            <div className="mt-6 text-center" data-id="element-62">
              <button onClick={() => setShowConsentPopup(false)} className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors" data-id="element-63">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>;
  };
  return <div className="container max-w-4xl mx-auto bg-white p-4 sm:p-6 rounded-lg shadow-lg" data-id="element-64">
      {/* Header with Logo Image */}
      <div className="mb-6" data-id="element-65">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gokj4dqyRmyFLxPowgMCDA/image.png" alt="Aatmshakti Institute of Integrated Medical Research" className="w-full h-auto mb-4" data-id="element-66" />
        <div className="text-xl sm:text-2xl font-bold text-center text-blue-800" data-id="element-67">
          Online Treatment / Consultation Form (ऑनलाइन उपचार / परामर्श प्रपत्र)
        </div>
      </div>
      {/* Render the consent popup */}
      <ConsentPopup data-id="element-68" />
      {/* Payment QR Code Section */}
      <div className="mb-8 p-3 sm:p-4 bg-blue-50 rounded-lg" data-id="element-69">
        <h3 className="text-lg sm:text-xl font-bold text-center text-blue-800 mb-3 sm:mb-4" data-id="element-70">
          Consultation Fee - ₹200
        </h3>
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-71">
          <div className="bg-white p-3 sm:p-4 rounded-lg shadow-sm" data-id="element-72">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tkvQYBZJCtiXUEKjqPRQFu/pasted-image.png" alt="Payment QR Code" className="w-full max-w-[160px] sm:max-w-[200px]" data-id="element-73" />
          </div>
          <div className="max-w-xs" data-id="element-74">
            <p className="text-sm sm:text-base text-gray-700 text-center mb-2" data-id="element-75">
              Scan the QR code to pay via UPI
            </p>
            <p className="text-sm sm:text-base text-gray-700 font-medium text-center" data-id="element-76">
              UPI ID: annukapoor@okicici
            </p>
            <p className="text-xs sm:text-sm text-gray-600 text-center mt-2" data-id="element-77">
              Please make the payment before submitting the form
            </p>
          </div>
        </div>
      </div>
      {/* Error message display */}
      {submissionError && <div className="bg-red-50 border-l-4 border-red-500 p-3 sm:p-4 mb-6" data-id="element-78">
          <div className="flex" data-id="element-79">
            <div className="ml-3" data-id="element-80">
              <p className="text-sm text-red-700" data-id="element-81">{submissionError}</p>
            </div>
          </div>
        </div>}
      {formSubmitted ? <div className="bg-green-50 border border-green-200 rounded-lg p-4 sm:p-6 text-center" data-id="element-82">
          <h2 className="text-xl sm:text-2xl font-bold text-green-700 mb-3 sm:mb-4" data-id="element-83">
            Form Submitted Successfully!
          </h2>
          <p className="text-base sm:text-lg mb-4" data-id="element-84">
            Your saved consultation pdf need to sent to{' '}
            <a href="https://wa.me/918303899990" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 font-semibold underline" data-id="element-85">
              +918303899990
            </a>{' '}
            via WhatsApp.
          </p>
          <button onClick={() => {
        setFormSubmitted(false);
        window.scrollTo(0, 0);
      }} className="px-4 sm:px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors" data-id="element-86">
            Submit Another Form
          </button>
        </div> : <form onSubmit={handleSubmit} className="form-group" id="whatsappForm" data-id="element-87">
          {/* Form fields */}
          <div className="space-y-4" data-id="element-88">
            {/* Basic Information */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-89">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-90">
                Basic Information
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-91">
                <div data-id="element-92">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-93">
                    Are You (क्या आप )
                  </span>
                  <select id="wru" className="w-full px-3 py-2 text-base border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.wru} onChange={handleChange} data-id="element-94">
                    <option value="" data-id="element-95">Select Option</option>
                    <option value="Acupuncturist" data-id="element-96">Acupuncturist</option>
                    <option value="Acupressure" data-id="element-97">Acupressure</option>
                    <option value="Sujok" data-id="element-98">Sujok</option>
                    <option value="No Knowledge" data-id="element-99">No Knowledge</option>
                  </select>
                </div>
                <div data-id="element-100">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-101">
                    Reference (संदर्भ)
                  </span>
                  <input type="text" id="reference" placeholder="Reference" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.reference} onChange={handleChange} data-id="element-102" />
                </div>
              </div>
            </div>
            {/* Personal Information */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-103">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-104">
                Personal Information
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-105">
                <div data-id="element-106">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-107">
                    Patient's Full Name (पूरा नाम)
                  </span>
                  <input type="text" id="name" placeholder="Enter Patient's Full Name" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.name} onChange={handleChange} data-id="element-108" />
                </div>
                <div data-id="element-109">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-110">
                    Father / Guardian Name (पिता/अभिभावक का नाम)
                  </span>
                  <input type="text" id="fgname" placeholder="Father / Guardian Name" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.fgname} onChange={handleChange} data-id="element-111" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-112">
                  <div data-id="element-113">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-114">
                      Age (आयु)
                    </span>
                    <input type="text" id="age" placeholder="Age" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.age} onChange={handleChange} data-id="element-115" />
                  </div>
                  <div data-id="element-116">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-117">
                      Gender (लिंग)
                    </span>
                    <select id="gender" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.gender} onChange={handleChange} data-id="element-118">
                      <option value="" data-id="element-119">Select Gender</option>
                      <option value="Male" data-id="element-120">Male</option>
                      <option value="Female" data-id="element-121">Female</option>
                      <option value="Other" data-id="element-122">Other</option>
                    </select>
                  </div>
                </div>
                <div data-id="element-123">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-124">
                    Email (ईमेल)
                  </span>
                  <input type="email" id="email" placeholder="Email" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.email} onChange={handleChange} data-id="element-125" />
                </div>
                <div data-id="element-126">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-127">
                    Address (पता)
                  </span>
                  <input type="text" id="address" placeholder="Address" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.address} onChange={handleChange} data-id="element-128" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-129">
                  <div data-id="element-130">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-131">
                      City (शहर)
                    </span>
                    <input type="text" id="city" placeholder="City" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.city} onChange={handleChange} data-id="element-132" />
                  </div>
                  <div data-id="element-133">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-134">
                      Pin Code (पिन कोड)
                    </span>
                    <input type="text" id="pin" placeholder="Pin Code" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.pin} onChange={handleChange} data-id="element-135" />
                  </div>
                </div>
                <div data-id="element-136">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-137">
                    WhatsApp Number (व्हाट्सएप नंबर)
                  </span>
                  <input type="text" id="whatsapp" placeholder="WhatsApp Number" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.whatsapp} onChange={handleChange} data-id="element-138" />
                </div>
              </div>
            </div>
            {/* Health & Lifestyle */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-139">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-140">
                Health & Lifestyle
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-141">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-142">
                  <div data-id="element-143">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-144">
                      Thirst (प्यास)
                    </span>
                    <select id="thirst" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.thirst} onChange={handleChange} data-id="element-145">
                      <option value="" data-id="element-146">Select Water Intake</option>
                      <option value="1-2 Glass" data-id="element-147">1-2 Glass</option>
                      <option value="3-4 Glass" data-id="element-148">3-4 Glass</option>
                      <option value="4-5 Glass" data-id="element-149">4-5 Glass</option>
                      <option value="6-7 Glass" data-id="element-150">6-7 Glass</option>
                      <option value="7-8 Glass" data-id="element-151">7-8 Glass</option>
                      <option value="8-10 Glass" data-id="element-152">8-10 Glass</option>
                      <option value="10+ Glass" data-id="element-153">10+ Glass</option>
                    </select>
                  </div>
                  <div data-id="element-154">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-155">
                      Appetite (भूख)
                    </span>
                    <select id="appetite" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.appetite} onChange={handleChange} data-id="element-156">
                      <option value="" data-id="element-157">Select Appetite</option>
                      <option value="Normal Appetite" data-id="element-158">Normal Appetite</option>
                      <option value="Poor Appetite and Loss of Appetite" data-id="element-159">
                        Poor Appetite and Loss of Appetite
                      </option>
                      <option value="Excess Appetite" data-id="element-160">Excess Appetite</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-161">
                  <div data-id="element-162">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-163">
                      Sleep (नींद)
                    </span>
                    <select id="sleep" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.sleep} onChange={handleChange} data-id="element-164">
                      <option value="" data-id="element-165">Select Sleep Pattern</option>
                      <option value="Normal Sleep" data-id="element-166">Normal Sleep</option>
                      <option value="Difficulty Falling Asleep" data-id="element-167">
                        Difficulty Falling Asleep
                      </option>
                      <option value="Frequent Waking" data-id="element-168">Frequent Waking</option>
                      <option value="Light or Unrestful Sleep" data-id="element-169">
                        Light or Unrestful Sleep
                      </option>
                      <option value="Dreams Disturbed (सपनों से परेशान)" data-id="element-170">
                        Dreams Disturbed (सपनों से परेशान)
                      </option>
                    </select>
                  </div>
                  <div data-id="element-171">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-172">
                      Dreams (सपने)
                    </span>
                    <select id="dreams" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.dreams} onChange={handleChange} data-id="element-173">
                      <option value="" data-id="element-174">Select Dream Pattern</option>
                      <option value="No Dreams" data-id="element-175">No Dreams</option>
                      <option value="Vivid or Disturbed Dreams" data-id="element-176">
                        Vivid or Disturbed Dreams
                      </option>
                      <option value="Nightmares" data-id="element-177">Nightmares</option>
                      <option value="Dream Categories (fearful, surprise, etc)" data-id="element-178">
                        Dream Categories (fearful, surprise, etc)
                      </option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-179">
                  <div data-id="element-180">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-181">
                      Personal Hygiene (व्यक्तिगत स्वच्छता)
                    </span>
                    <input type="text" id="hygiene" placeholder="Personal Hygiene" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.hygiene} onChange={handleChange} data-id="element-182" />
                  </div>
                  <div data-id="element-183">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-184">
                      Addiction if Any (लत यदि कोई हो)
                    </span>
                    <input type="text" id="addiction" placeholder="Addiction if Any" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.addiction} onChange={handleChange} data-id="element-185" />
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-186">
                  <div data-id="element-187">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-188">
                      Food Habits and Nutrition (भोजन की आदतें और पोषण)
                    </span>
                    <div className="grid grid-cols-1 gap-2" data-id="element-189">
                      <label className="flex items-center space-x-2" data-id="element-190">
                        <input type="checkbox" name="fruits" checked={formData.foodHabits.fruits} onChange={handleFoodHabitsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-191" />
                        <span className="text-sm" data-id="element-192">
                          Take Fruits and Dry fruits & Nuts (soaked over night)
                          (फल और सूखे मेवे और नट्स (रात भर भिगोए हुए))
                        </span>
                      </label>
                      <label className="flex items-center space-x-2" data-id="element-193">
                        <input type="checkbox" name="healthyFood" checked={formData.foodHabits.healthyFood} onChange={handleFoodHabitsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-194" />
                        <span className="text-sm" data-id="element-195">
                          Take 3 Times Healthy Food (3 बार स्वस्थ भोजन लें)
                        </span>
                      </label>
                      <label className="flex items-center space-x-2" data-id="element-196">
                        <input type="checkbox" name="noWaterBeforeAfter" checked={formData.foodHabits.noWaterBeforeAfter} onChange={handleFoodHabitsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-197" />
                        <span className="text-sm" data-id="element-198">
                          Don't take water before any meal before and after 45
                          min (किसी भी भोजन से पहले और बाद में 45 मिनट तक पानी न
                          पिएं)
                        </span>
                      </label>
                      <label className="flex items-center space-x-2" data-id="element-199">
                        <input type="checkbox" name="waterBeforeAfter" checked={formData.foodHabits.waterBeforeAfter} onChange={handleFoodHabitsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-200" />
                        <span className="text-sm" data-id="element-201">
                          Take water before any meal before and after 45 min
                          (किसी भी भोजन से पहले और बाद में 45 मिनट पानी पिएं)
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Medical History Section */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-202">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-203">
                Medical History
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-204">
                <div data-id="element-205">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-206">
                    Are you Suffering or Suffered in Past with any of the
                    disease(s)
                  </span>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-207">
                    <label className="flex items-center space-x-2" data-id="element-208">
                      <input type="checkbox" name="none" checked={!Object.values(formData.medicalHistory).some(value => value === true)} onChange={e => {
                    if (e.target.checked) {
                      // If None is checked, uncheck all other options
                      const resetMedicalHistory = {};
                      Object.keys(formData.medicalHistory).forEach(key => {
                        resetMedicalHistory[key] = false;
                      });
                      setFormData(prev => ({
                        ...prev,
                        medicalHistory: resetMedicalHistory
                      }));
                    }
                  }} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-209" />
                      <span className="text-sm font-medium" data-id="element-210">None</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-211">
                      <input type="checkbox" name="diabetic" checked={formData.medicalHistory.diabetic} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-212" />
                      <span className="text-sm" data-id="element-213">Diabetic</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-214">
                      <input type="checkbox" name="preDiabetic" checked={formData.medicalHistory.preDiabetic} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-215" />
                      <span className="text-sm" data-id="element-216">Pre-Diabetic</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-217">
                      <input type="checkbox" name="heartProblem" checked={formData.medicalHistory.heartProblem} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-218" />
                      <span className="text-sm" data-id="element-219">Heart Related Problem</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-220">
                      <input type="checkbox" name="kidneyProblem" checked={formData.medicalHistory.kidneyProblem} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-221" />
                      <span className="text-sm" data-id="element-222">Kidney Related Problem</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-223">
                      <input type="checkbox" name="highBloodPressure" checked={formData.medicalHistory.highBloodPressure} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-224" />
                      <span className="text-sm" data-id="element-225">High Blood Pressure</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-226">
                      <input type="checkbox" name="arthritis" checked={formData.medicalHistory.arthritis} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-227" />
                      <span className="text-sm" data-id="element-228">Arthritis</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-229">
                      <input type="checkbox" name="cancer" checked={formData.medicalHistory.cancer} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-230" />
                      <span className="text-sm" data-id="element-231">Cancer</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-232">
                      <input type="checkbox" name="hivAids" checked={formData.medicalHistory.hivAids} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-233" />
                      <span className="text-sm" data-id="element-234">HIV/AIDS</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-235">
                      <input type="checkbox" name="hepatitis" checked={formData.medicalHistory.hepatitis} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-236" />
                      <span className="text-sm" data-id="element-237">Hepatitis</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-238">
                      <input type="checkbox" name="stroke" checked={formData.medicalHistory.stroke} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-239" />
                      <span className="text-sm" data-id="element-240">Stroke</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-241">
                      <input type="checkbox" name="paralysis" checked={formData.medicalHistory.paralysis} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-242" />
                      <span className="text-sm" data-id="element-243">Paralysis</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-244">
                      <input type="checkbox" name="alzheimers" checked={formData.medicalHistory.alzheimers} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-245" />
                      <span className="text-sm" data-id="element-246">Alzheimer's Disease</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-247">
                      <input type="checkbox" name="asthma" checked={formData.medicalHistory.asthma} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-248" />
                      <span className="text-sm" data-id="element-249">Asthma</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-250">
                      <input type="checkbox" name="organTransplant" checked={formData.medicalHistory.organTransplant} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-251" />
                      <span className="text-sm" data-id="element-252">Any Organ Transplant</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {/* Physical Attributes */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-253">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-254">
                Physical Attributes
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-255">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-256">
                  <div data-id="element-257">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-258">
                      Body Type (शरीर के प्रकार)
                    </span>
                    <select id="body" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.body} onChange={handleChange} data-id="element-259">
                      <option value="" data-id="element-260">Select Body Type</option>
                      <option value="Underweight (कम वजन)" data-id="element-261">
                        Underweight (कम वजन)
                      </option>
                      <option value="Normal weight (सामान्य वजन)" data-id="element-262">
                        Normal weight (सामान्य वजन)
                      </option>
                      <option value="Overweight (अधिक वजन)" data-id="element-263">
                        Overweight (अधिक वजन)
                      </option>
                      <option value="Obese (मोटापा)" data-id="element-264">Obese (मोटापा)</option>
                    </select>
                  </div>
                  <div data-id="element-265">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-266">
                      Temperature (तापमान)
                    </span>
                    <select id="temperature" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.temperature} onChange={handleChange} data-id="element-267">
                      <option value="" data-id="element-268">Select Temperature</option>
                      <option value="Normal" data-id="element-269">Normal</option>
                      <option value="Low" data-id="element-270">Low</option>
                      <option value="High" data-id="element-271">High</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-272">
                  <div data-id="element-273">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-274">
                      Mental Condition (मानसिक हालत)
                    </span>
                    <input type="text" id="mentalcondition" placeholder="Mental Condition" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.mentalcondition} onChange={handleChange} data-id="element-275" />
                  </div>
                  <div data-id="element-276">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-277">
                      Blood Pressure (रक्तचाप)
                    </span>
                    <select id="bp" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.bp} onChange={handleChange} data-id="element-278">
                      <option value="" data-id="element-279">Select Blood Pressure</option>
                      <option value="Normal" data-id="element-280">Normal</option>
                      <option value="Low" data-id="element-281">Low</option>
                      <option value="High" data-id="element-282">High</option>
                    </select>
                  </div>
                </div>
                <div data-id="element-283">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-284">
                    Pulse rate (नाड़ी की गति)
                  </span>
                  <input type="text" id="pulse" placeholder="Pulse rate" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.pulse} onChange={handleChange} data-id="element-285" />
                </div>
                <div data-id="element-286">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-287">
                    Did you want to add Pulse details? (क्या आप पल्स विवरण
                    जोड़ना चाहते हैं?)
                  </span>
                  <select id="addPulseDetails" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.addPulseDetails} onChange={handleChange} data-id="element-288">
                    <option value="" data-id="element-289">Select Option</option>
                    <option value="Yes" data-id="element-290">Yes (हां)</option>
                    <option value="No" data-id="element-291">No (नहीं)</option>
                  </select>
                </div>
                {formData.addPulseDetails === 'Yes' && <div className="mt-4 p-4 bg-blue-100 rounded-md" data-id="element-292">
                    <h4 className="text-md font-semibold text-blue-900 mb-3" data-id="element-293">
                      Pulse Diagnosis Details (पल्स निदान विवरण)
                    </h4>
                    <div className="mb-4 bg-white p-3 rounded-md" data-id="element-294">
                      <img src="https://cdn.magicpatterns.com/uploads/dw8qhsv5z5RPqU2BKWhhBZ/image.png" alt="Pulse Diagnosis Points - TCM Hand Diagram" className="w-full max-w-2xl mx-auto" data-id="element-295" />
                    </div>
                    <div className="grid grid-cols-1 gap-4" data-id="element-296">
                      <div data-id="element-297">
                        <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-298">
                          Left Cun - Heart/Small Intestine (बाएं कुन - हृदय/छोटी
                          आंत)
                        </span>
                        <select name="leftCun" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.pulseDetails.leftCun} onChange={handlePulseDetailsChange} data-id="element-299">
                          <option value="" data-id="element-300">Select Pulse Quality</option>
                          <option value="Normal" data-id="element-301">Normal</option>
                          <option value="Empty (Qi and Blood deficiency)" data-id="element-302">
                            Empty (Qi and Blood deficiency)
                          </option>
                          <option value="Full (Excess condition)" data-id="element-303">
                            Full (Excess condition)
                          </option>
                          <option value="Slippery (Phlegm, Food retention, Pregnancy)" data-id="element-304">
                            Slippery (Phlegm, Food retention, Pregnancy)
                          </option>
                          <option value="Choppy (Blood stasis, Qi stagnation)" data-id="element-305">
                            Choppy (Blood stasis, Qi stagnation)
                          </option>
                          <option value="Wiry (Liver disorder, Pain, Stress)" data-id="element-306">
                            Wiry (Liver disorder, Pain, Stress)
                          </option>
                          <option value="Superficial (External condition, Defensive Qi disorder)" data-id="element-307">
                            Superficial (External condition, Defensive Qi
                            disorder)
                          </option>
                          <option value="Deep (Internal condition, Organ disorder)" data-id="element-308">
                            Deep (Internal condition, Organ disorder)
                          </option>
                          <option value="Slow (Cold syndrome, Yang deficiency)" data-id="element-309">
                            Slow (Cold syndrome, Yang deficiency)
                          </option>
                          <option value="Rapid (Heat syndrome)" data-id="element-310">
                            Rapid (Heat syndrome)
                          </option>
                        </select>
                      </div>
                      <div data-id="element-311">
                        <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-312">
                          Left Guan - Liver/Gallbladder (बाएं गुआन -
                          यकृत/पित्ताशय)
                        </span>
                        <select name="leftGuan" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.pulseDetails.leftGuan} onChange={handlePulseDetailsChange} data-id="element-313">
                          <option value="" data-id="element-314">Select Pulse Quality</option>
                          <option value="Normal" data-id="element-315">Normal</option>
                          <option value="Empty (Qi and Blood deficiency)" data-id="element-316">
                            Empty (Qi and Blood deficiency)
                          </option>
                          <option value="Full (Excess condition)" data-id="element-317">
                            Full (Excess condition)
                          </option>
                          <option value="Slippery (Phlegm, Food retention, Pregnancy)" data-id="element-318">
                            Slippery (Phlegm, Food retention, Pregnancy)
                          </option>
                          <option value="Choppy (Blood stasis, Qi stagnation)" data-id="element-319">
                            Choppy (Blood stasis, Qi stagnation)
                          </option>
                          <option value="Wiry (Liver disorder, Pain, Stress)" data-id="element-320">
                            Wiry (Liver disorder, Pain, Stress)
                          </option>
                          <option value="Superficial (External condition, Defensive Qi disorder)" data-id="element-321">
                            Superficial (External condition, Defensive Qi
                            disorder)
                          </option>
                          <option value="Deep (Internal condition, Organ disorder)" data-id="element-322">
                            Deep (Internal condition, Organ disorder)
                          </option>
                          <option value="Slow (Cold syndrome, Yang deficiency)" data-id="element-323">
                            Slow (Cold syndrome, Yang deficiency)
                          </option>
                          <option value="Rapid (Heat syndrome)" data-id="element-324">
                            Rapid (Heat syndrome)
                          </option>
                        </select>
                      </div>
                      <div data-id="element-325">
                        <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-326">
                          Left Chi - Kidney Yin (बाएं ची - किडनी यिन)
                        </span>
                        <select name="leftChi" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.pulseDetails.leftChi} onChange={handlePulseDetailsChange} data-id="element-327">
                          <option value="" data-id="element-328">Select Pulse Quality</option>
                          <option value="Normal" data-id="element-329">Normal</option>
                          <option value="Empty (Qi and Blood deficiency)" data-id="element-330">
                            Empty (Qi and Blood deficiency)
                          </option>
                          <option value="Full (Excess condition)" data-id="element-331">
                            Full (Excess condition)
                          </option>
                          <option value="Slippery (Phlegm, Food retention, Pregnancy)" data-id="element-332">
                            Slippery (Phlegm, Food retention, Pregnancy)
                          </option>
                          <option value="Choppy (Blood stasis, Qi stagnation)" data-id="element-333">
                            Choppy (Blood stasis, Qi stagnation)
                          </option>
                          <option value="Wiry (Liver disorder, Pain, Stress)" data-id="element-334">
                            Wiry (Liver disorder, Pain, Stress)
                          </option>
                          <option value="Superficial (External condition, Defensive Qi disorder)" data-id="element-335">
                            Superficial (External condition, Defensive Qi
                            disorder)
                          </option>
                          <option value="Deep (Internal condition, Organ disorder)" data-id="element-336">
                            Deep (Internal condition, Organ disorder)
                          </option>
                          <option value="Slow (Cold syndrome, Yang deficiency)" data-id="element-337">
                            Slow (Cold syndrome, Yang deficiency)
                          </option>
                          <option value="Rapid (Heat syndrome)" data-id="element-338">
                            Rapid (Heat syndrome)
                          </option>
                        </select>
                      </div>
                      <div data-id="element-339">
                        <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-340">
                          Right Cun - Lung/Large Intestine (दाएं कुन -
                          फेफड़े/बड़ी आंत)
                        </span>
                        <select name="rightCun" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.pulseDetails.rightCun} onChange={handlePulseDetailsChange} data-id="element-341">
                          <option value="" data-id="element-342">Select Pulse Quality</option>
                          <option value="Normal" data-id="element-343">Normal</option>
                          <option value="Empty (Qi and Blood deficiency)" data-id="element-344">
                            Empty (Qi and Blood deficiency)
                          </option>
                          <option value="Full (Excess condition)" data-id="element-345">
                            Full (Excess condition)
                          </option>
                          <option value="Slippery (Phlegm, Food retention, Pregnancy)" data-id="element-346">
                            Slippery (Phlegm, Food retention, Pregnancy)
                          </option>
                          <option value="Choppy (Blood stasis, Qi stagnation)" data-id="element-347">
                            Choppy (Blood stasis, Qi stagnation)
                          </option>
                          <option value="Wiry (Liver disorder, Pain, Stress)" data-id="element-348">
                            Wiry (Liver disorder, Pain, Stress)
                          </option>
                          <option value="Superficial (External condition, Defensive Qi disorder)" data-id="element-349">
                            Superficial (External condition, Defensive Qi
                            disorder)
                          </option>
                          <option value="Deep (Internal condition, Organ disorder)" data-id="element-350">
                            Deep (Internal condition, Organ disorder)
                          </option>
                          <option value="Slow (Cold syndrome, Yang deficiency)" data-id="element-351">
                            Slow (Cold syndrome, Yang deficiency)
                          </option>
                          <option value="Rapid (Heat syndrome)" data-id="element-352">
                            Rapid (Heat syndrome)
                          </option>
                        </select>
                      </div>
                      <div data-id="element-353">
                        <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-354">
                          Right Guan - Spleen/Stomach (दाएं गुआन - प्लीहा/पेट)
                        </span>
                        <select name="rightGuan" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.pulseDetails.rightGuan} onChange={handlePulseDetailsChange} data-id="element-355">
                          <option value="" data-id="element-356">Select Pulse Quality</option>
                          <option value="Normal" data-id="element-357">Normal</option>
                          <option value="Empty (Qi and Blood deficiency)" data-id="element-358">
                            Empty (Qi and Blood deficiency)
                          </option>
                          <option value="Full (Excess condition)" data-id="element-359">
                            Full (Excess condition)
                          </option>
                          <option value="Slippery (Phlegm, Food retention, Pregnancy)" data-id="element-360">
                            Slippery (Phlegm, Food retention, Pregnancy)
                          </option>
                          <option value="Choppy (Blood stasis, Qi stagnation)" data-id="element-361">
                            Choppy (Blood stasis, Qi stagnation)
                          </option>
                          <option value="Wiry (Liver disorder, Pain, Stress)" data-id="element-362">
                            Wiry (Liver disorder, Pain, Stress)
                          </option>
                          <option value="Superficial (External condition, Defensive Qi disorder)" data-id="element-363">
                            Superficial (External condition, Defensive Qi
                            disorder)
                          </option>
                          <option value="Deep (Internal condition, Organ disorder)" data-id="element-364">
                            Deep (Internal condition, Organ disorder)
                          </option>
                          <option value="Slow (Cold syndrome, Yang deficiency)" data-id="element-365">
                            Slow (Cold syndrome, Yang deficiency)
                          </option>
                          <option value="Rapid (Heat syndrome)" data-id="element-366">
                            Rapid (Heat syndrome)
                          </option>
                        </select>
                      </div>
                      <div data-id="element-367">
                        <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-368">
                          Right Chi - Kidney Yang (दाएं ची - किडनी यांग)
                        </span>
                        <select name="rightChi" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.pulseDetails.rightChi} onChange={handlePulseDetailsChange} data-id="element-369">
                          <option value="" data-id="element-370">Select Pulse Quality</option>
                          <option value="Normal" data-id="element-371">Normal</option>
                          <option value="Empty (Qi and Blood deficiency)" data-id="element-372">
                            Empty (Qi and Blood deficiency)
                          </option>
                          <option value="Full (Excess condition)" data-id="element-373">
                            Full (Excess condition)
                          </option>
                          <option value="Slippery (Phlegm, Food retention, Pregnancy)" data-id="element-374">
                            Slippery (Phlegm, Food retention, Pregnancy)
                          </option>
                          <option value="Choppy (Blood stasis, Qi stagnation)" data-id="element-375">
                            Choppy (Blood stasis, Qi stagnation)
                          </option>
                          <option value="Wiry (Liver disorder, Pain, Stress)" data-id="element-376">
                            Wiry (Liver disorder, Pain, Stress)
                          </option>
                          <option value="Superficial (External condition, Defensive Qi disorder)" data-id="element-377">
                            Superficial (External condition, Defensive Qi
                            disorder)
                          </option>
                          <option value="Deep (Internal condition, Organ disorder)" data-id="element-378">
                            Deep (Internal condition, Organ disorder)
                          </option>
                          <option value="Slow (Cold syndrome, Yang deficiency)" data-id="element-379">
                            Slow (Cold syndrome, Yang deficiency)
                          </option>
                          <option value="Rapid (Heat syndrome)" data-id="element-380">
                            Rapid (Heat syndrome)
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>}
              </div>
            </div>
            {/* Bodily Functions */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-381">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-382">
                Bodily Functions
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-383">
                <div data-id="element-384">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-385">
                    Bowel Movement (मल त्याग)
                  </span>
                  <select id="bowel" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.bowel} onChange={handleChange} data-id="element-386">
                    <option value="" data-id="element-387">Select Option</option>
                    <option value="1 time in a day (morning)" data-id="element-388">
                      1 time in a day (morning) (दिन में 1 बार (सुबह))
                    </option>
                    <option value="1 Time in a day(Any time)" data-id="element-389">
                      1 Time in a day(Any time) (दिन में 1 बार (किसी भी समय))
                    </option>
                    <option value="2 Times in a day (Morning / Evening)" data-id="element-390">
                      2 Times in a day (Morning / Evening) (दिन में 2 बार (सुबह
                      / शाम))
                    </option>
                    <option value="After meal" data-id="element-391">After meal (भोजन के बाद)</option>
                    <option value="Before meal" data-id="element-392">
                      Before meal (भोजन से पहले)
                    </option>
                    <option value="Other" data-id="element-393">Other (अन्य)</option>
                  </select>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-394">
                  <div data-id="element-395">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-396">
                      Urine Frequency (In Day) (दिन में पेशाब की आवृत्ति)
                    </span>
                    <select id="urineFrequencyDay" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.urineFrequencyDay} onChange={handleChange} data-id="element-397">
                      <option value="" data-id="element-398">Select Option</option>
                      <option value="No" data-id="element-399">No (नहीं)</option>
                      <option value="Normal" data-id="element-400">Normal (सामान्य)</option>
                      <option value="Excess" data-id="element-401">Excess (अधिक)</option>
                      <option value="Less" data-id="element-402">Less (कम)</option>
                    </select>
                  </div>
                  <div data-id="element-403">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-404">
                      Urine Frequency (In Night) (रात में पेशाब की आवृत्ति)
                    </span>
                    <select id="urineFrequencyNight" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.urineFrequencyNight} onChange={handleChange} data-id="element-405">
                      <option value="" data-id="element-406">Select Option</option>
                      <option value="No" data-id="element-407">No (नहीं)</option>
                      <option value="Normal" data-id="element-408">Normal (सामान्य)</option>
                      <option value="Excess" data-id="element-409">Excess (अधिक)</option>
                      <option value="Less" data-id="element-410">Less (कम)</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-411">
                  <div data-id="element-412">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-413">
                      Urine Color (मूत्र का रंग)
                    </span>
                    <select id="urineColor" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.urineColor} onChange={handleChange} data-id="element-414">
                      <option value="" data-id="element-415">Select Color</option>
                      <option value="Pale Yellow (हल्का पीला)" data-id="element-416">
                        Pale Yellow (हल्का पीला)
                      </option>
                      <option value="Dark Yellow (गहरा पीला)" data-id="element-417">
                        Dark Yellow (गहरा पीला)
                      </option>
                      <option value="Orange (नारंगी)" data-id="element-418">Orange (नारंगी)</option>
                      <option value="Pink or Red (गुलाबी या लाल)" data-id="element-419">
                        Pink or Red (गुलाबी या लाल)
                      </option>
                      <option value="Green or Blue (हरा या नीला)" data-id="element-420">
                        Green or Blue (हरा या नीला)
                      </option>
                      <option value="Brown (भूरा)" data-id="element-421">Brown (भूरा)</option>
                      <option value="White (सफेद)" data-id="element-422">White (सफेद)</option>
                    </select>
                  </div>
                  <div data-id="element-423">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-424">
                      Urine Smell (मूत्र की गंध)
                    </span>
                    <select id="urineSmell" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.urineSmell} onChange={handleChange} data-id="element-425">
                      <option value="" data-id="element-426">Select Smell</option>
                      <option value="Normal Smell (सामान्य गंध)" data-id="element-427">
                        Normal Smell (सामान्य गंध)
                      </option>
                      <option value="तीव्र गंध (Strong Smell)" data-id="element-428">
                        तीव्र गंध (Strong Smell)
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            {/* Physical Appearance */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-429">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-430">
                Physical Appearance
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-431">
                <div data-id="element-432">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-433">
                    Skin (त्वचा)
                  </span>
                  <select id="skin" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.skin} onChange={handleChange} data-id="element-434">
                    <option value="" data-id="element-435">Select Skin Type</option>
                    <option value="Normal Skin (सामान्य त्वचा)" data-id="element-436">
                      Normal Skin (सामान्य त्वचा)
                    </option>
                    <option value="Oily Skin (तैलीय त्वचा)" data-id="element-437">
                      Oily Skin (तैलीय त्वचा)
                    </option>
                    <option value="Dry Skin (शुष्क त्वचा)" data-id="element-438">
                      Dry Skin (शुष्क त्वचा)
                    </option>
                    <option value="Combination Skin (मिश्रित त्वचा)" data-id="element-439">
                      Combination Skin (मिश्रित त्वचा)
                    </option>
                    <option value="Sensitive Skin (संवेदनशील त्वचा)" data-id="element-440">
                      Sensitive Skin (संवेदनशील त्वचा)
                    </option>
                  </select>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-441">
                  <div data-id="element-442">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-443">
                      Scalp(Hair) (खोपड़ी(बाल))
                    </span>
                    <select id="shair" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.shair} onChange={handleChange} data-id="element-444">
                      <option value="" data-id="element-445">Select Scalp Type</option>
                      <option value="Normal/Balanced Scalp (सामान्य/संतुलित खोपड़ी)" data-id="element-446">
                        Normal/Balanced Scalp (सामान्य/संतुलित खोपड़ी)
                      </option>
                      <option value="Oily Scalp (तैलीय खोपड़ी)" data-id="element-447">
                        Oily Scalp (तैलीय खोपड़ी)
                      </option>
                      <option value="Dry Scalp (रूखी खोपड़ी)" data-id="element-448">
                        Dry Scalp (रूखी खोपड़ी)
                      </option>
                      <option value="Sensitive Scalp (संवेदनशील खोपड़ी)" data-id="element-449">
                        Sensitive Scalp (संवेदनशील खोपड़ी)
                      </option>
                      <option value="Combination Scalp (मिश्रित खोपड़ी)" data-id="element-450">
                        Combination Scalp (मिश्रित खोपड़ी)
                      </option>
                      <option value="Early Baldness (प्रारंभिक गंजापन)" data-id="element-451">
                        Early Baldness (प्रारंभिक गंजापन)
                      </option>
                      <option value="Hair Fall (बाल झड़ना)" data-id="element-452">
                        Hair Fall (बाल झड़ना)
                      </option>
                      <option value="Early Grey Hair (जल्दी सफेद बाल)" data-id="element-453">
                        Early Grey Hair (जल्दी सफेद बाल)
                      </option>
                      <option value="Dandruff (रूसी)" data-id="element-454">Dandruff (रूसी)</option>
                    </select>
                  </div>
                  <div data-id="element-455">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-456">
                      Body(Hair) (शरीर पर बाल)
                    </span>
                    <select id="bhair" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.bhair} onChange={handleChange} data-id="element-457">
                      <option value="" data-id="element-458">Select Type</option>
                      <option value="No Hair (कोई बाल नहीं)" data-id="element-459">
                        No Hair (कोई बाल नहीं)
                      </option>
                      <option value="Less Hair (कम बाल)" data-id="element-460">
                        Less Hair (कम बाल)
                      </option>
                      <option value="Normal Hair (सामान्य बाल)" data-id="element-461">
                        Normal Hair (सामान्य बाल)
                      </option>
                      <option value="Excess Hair (अधिक बाल)" data-id="element-462">
                        Excess Hair (अधिक बाल)
                      </option>
                    </select>
                  </div>
                </div>
                <div data-id="element-463">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-464">
                    Nails (नाखून)
                  </span>
                  <select id="nails" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.nails} onChange={handleChange} data-id="element-465">
                    <option value="" data-id="element-466">Select Nail Condition</option>
                    <option value="Normal (सामान्य)" data-id="element-467">Normal (सामान्य)</option>
                    <option value="Dry and brittle (सूखे और भंगुर)" data-id="element-468">
                      Dry and brittle (सूखे और भंगुर)
                    </option>
                    <option value="Soft and brittle (नरम और भंगुर)" data-id="element-469">
                      Soft and brittle (नरम और भंगुर)
                    </option>
                    <option value="Vertical Lines (ऊर्ध्वाधर रेखाएँ)" data-id="element-470">
                      Vertical Lines (ऊर्ध्वाधर रेखाएँ)
                    </option>
                    <option value="Horizontal lines (क्षैतिज रेखाएँ)" data-id="element-471">
                      Horizontal lines (क्षैतिज रेखाएँ)
                    </option>
                    <option value="Discolored (विवर्ण)" data-id="element-472">
                      Discolored (विवर्ण)
                    </option>
                    <option value="Thick (मोटे)" data-id="element-473">Thick (मोटे)</option>
                    <option value="Thin (पतले)" data-id="element-474">Thin (पतले)</option>
                  </select>
                </div>
              </div>
            </div>
            {/* Body & Mouth Odor */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-475">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-476">
                Body & Mouth Odor
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-477">
                <div data-id="element-478">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-479">
                    Body Odor (शरीर की गंध)
                  </span>
                  <select id="bodyOdor" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.bodyOdor} onChange={handleChange} data-id="element-480">
                    <option value="" data-id="element-481">Select Body Odor</option>
                    <option value="Normal / No Odor (सामान्य / कोई गंध नहीं)" data-id="element-482">
                      Normal / No Odor (सामान्य / कोई गंध नहीं)
                    </option>
                    <option value="Fragrant (सुगंधित)" data-id="element-483">
                      Fragrant (सुगंधित)
                    </option>
                    <option value="Woody/Resinous (वुडी/रेजिनस)" data-id="element-484">
                      Woody/Resinous (वुडी/रेजिनस)
                    </option>
                    <option value="Minty (पुदीना)" data-id="element-485">Minty (पुदीना)</option>
                    <option value="Sweet (मीठा)" data-id="element-486">Sweet (मीठा)</option>
                    <option value="Chemical (रासायनिक)" data-id="element-487">
                      Chemical (रासायनिक)
                    </option>
                    <option value="Popcorn (पॉपकॉर्न)" data-id="element-488">
                      Popcorn (पॉपकॉर्न)
                    </option>
                    <option value="Citrus (नींबू)" data-id="element-489">Citrus (नींबू)</option>
                    <option value="Fruity (non-citrus) (फल (गैर-साइट्रस))" data-id="element-490">
                      Fruity (non-citrus) (फल (गैर-साइट्रस))
                    </option>
                    <option value="Pungent (तीखा)" data-id="element-491">Pungent (तीखा)</option>
                    <option value="Putrid (सड़ा हुआ)" data-id="element-492">Putrid (सड़ा हुआ)</option>
                  </select>
                </div>
                <div data-id="element-493">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-494">
                    Mouth Odor (मुंह की गंध)
                  </span>
                  <select id="mouthOdor" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.mouthOdor} onChange={handleChange} data-id="element-495">
                    <option value="" data-id="element-496">Select Mouth Odor</option>
                    <option value="Normal / No Odor (सामान्य / कोई गंध नहीं)" data-id="element-497">
                      Normal / No Odor (सामान्य / कोई गंध नहीं)
                    </option>
                    <option value="Fragrant (सुगंधित)" data-id="element-498">
                      Fragrant (सुगंधित)
                    </option>
                    <option value="Woody/Resinous (वुडी/रेजिनस)" data-id="element-499">
                      Woody/Resinous (वुडी/रेजिनस)
                    </option>
                    <option value="Minty (पुदीना)" data-id="element-500">Minty (पुदीना)</option>
                    <option value="Sweet (मीठा)" data-id="element-501">Sweet (मीठा)</option>
                    <option value="Chemical (रासायनिक)" data-id="element-502">
                      Chemical (रासायनिक)
                    </option>
                    <option value="Popcorn (पॉपकॉर्न)" data-id="element-503">
                      Popcorn (पॉपकॉर्न)
                    </option>
                    <option value="Citrus (नींबू)" data-id="element-504">Citrus (नींबू)</option>
                    <option value="Fruity (non-citrus) (फल (गैर-साइट्रस))" data-id="element-505">
                      Fruity (non-citrus) (फल (गैर-साइट्रस))
                    </option>
                    <option value="Pungent (तीखा)" data-id="element-506">Pungent (तीखा)</option>
                    <option value="Putrid (सड़ा हुआ)" data-id="element-507">Putrid (सड़ा हुआ)</option>
                  </select>
                </div>
              </div>
            </div>
            {/* Body Parts */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-508">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-509">
                Body Parts
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-510">
                <div data-id="element-511">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-512">
                    Throat (गला)
                  </span>
                  <select id="throat" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.throat} onChange={handleChange} data-id="element-513">
                    <option value="" data-id="element-514">Select Throat Condition</option>
                    <option value="Normal / No Problem (सामान्य / कोई समस्या नहीं)" data-id="element-515">
                      Normal / No Problem (सामान्य / कोई समस्या नहीं)
                    </option>
                    <option value="Tonsillitis (टॉन्सिलाइटिस)" data-id="element-516">
                      Tonsillitis (टॉन्सिलाइटिस)
                    </option>
                    <option value="Strep throat (स्ट्रेप थ्रोट)" data-id="element-517">
                      Strep throat (स्ट्रेप थ्रोट)
                    </option>
                    <option value="Laryngitis (लैरिंजाइटिस)" data-id="element-518">
                      Laryngitis (लैरिंजाइटिस)
                    </option>
                    <option value="Pharyngitis (फेरिंजाइटिस)" data-id="element-519">
                      Pharyngitis (फेरिंजाइटिस)
                    </option>
                  </select>
                </div>
                <div data-id="element-520">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-521">
                    Edema (सूजन)
                  </span>
                  <select id="oedma" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.oedma} onChange={handleChange} data-id="element-522">
                    <option value="" data-id="element-523">Select Edema Type</option>
                    <option value="Normal / No Problem (सामान्य / कोई समस्या नहीं)" data-id="element-524">
                      Normal / No Problem (सामान्य / कोई समस्या नहीं)
                    </option>
                    <option value="Pitting edema (गड्ढादार)" data-id="element-525">
                      Pitting edema (गड्ढादार)
                    </option>
                    <option value="Non pitted type (गैर-गड्ढेदार)" data-id="element-526">
                      Non pitted type (गैर-गड्ढेदार)
                    </option>
                  </select>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-527">
                  <div data-id="element-528">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-529">
                      Eyes (आँखें)
                    </span>
                    <input type="text" id="eyes" placeholder="Eyes" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.eyes} onChange={handleChange} data-id="element-530" />
                  </div>
                  <div data-id="element-531">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-532">
                      Ears (कान)
                    </span>
                    <input type="text" id="ears" placeholder="Ears" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.ears} onChange={handleChange} data-id="element-533" />
                  </div>
                </div>
                <div data-id="element-534">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-535">
                    Lips (होंठ)
                  </span>
                  <select id="lips" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.lips} onChange={handleChange} data-id="element-536">
                    <option value="" data-id="element-537">Select Lips Condition</option>
                    <option value="Normal / No Problem (सामान्य / कोई समस्या नहीं)" data-id="element-538">
                      Normal / No Problem (सामान्य / कोई समस्या नहीं)
                    </option>
                    <option value="Chapped lips (फटे होंठ)" data-id="element-539">
                      Chapped lips (फटे होंठ)
                    </option>
                    <option value="Cold sores (herpes simplex) (ठंडे घाव (हरपीज सिम्प्लेक्स))" data-id="element-540">
                      Cold sores (herpes simplex) (ठंडे घाव (हरपीज सिम्प्लेक्स))
                    </option>
                    <option value="Angular cheilitis (कोणीय चेइलिटिस)" data-id="element-541">
                      Angular cheilitis (कोणीय चेइलिटिस)
                    </option>
                    <option value="Eczematous cheilitis (एक्जिमेटस चेइलिटिस)" data-id="element-542">
                      Eczematous cheilitis (एक्जिमेटस चेइलिटिस)
                    </option>
                    <option value="Infective cheilitis (संक्रामक चेइलिटिस)" data-id="element-543">
                      Infective cheilitis (संक्रामक चेइलिटिस)
                    </option>
                    <option value="Actinic cheilitis (एक्टिनिक चेइलिटिस)" data-id="element-544">
                      Actinic cheilitis (एक्टिनिक चेइलिटिस)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            {/* Female-specific section */}
            {isFemale && <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-545">
                <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-546">
                  Female-specific Information
                </h3>
                <div className="grid grid-cols-1 gap-4" data-id="element-547">
                  <div data-id="element-548">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-549">
                      Are you Pregnant? (क्या आप गर्भवती हैं?)
                    </span>
                    <select id="isPregnant" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.isPregnant} onChange={handleChange} data-id="element-550">
                      <option value="" data-id="element-551">Select Option</option>
                      <option value="Yes" data-id="element-552">Yes (हां)</option>
                      <option value="No" data-id="element-553">No (नहीं)</option>
                    </select>
                  </div>
                  {formData.isPregnant === 'Yes' && <div data-id="element-554">
                      <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-555">
                        Pregnancy Month (गर्भावस्था का महीना)
                      </span>
                      <select id="pregnancyMonth" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.pregnancyMonth} onChange={handleChange} data-id="element-556">
                        <option value="" data-id="element-557">Select Month</option>
                        <option value="1" data-id="element-558">1</option>
                        <option value="2" data-id="element-559">2</option>
                        <option value="3" data-id="element-560">3</option>
                        <option value="4" data-id="element-561">4</option>
                        <option value="5" data-id="element-562">5</option>
                        <option value="6" data-id="element-563">6</option>
                        <option value="7" data-id="element-564">7</option>
                        <option value="8" data-id="element-565">8</option>
                        <option value="9" data-id="element-566">9</option>
                        <option value="10" data-id="element-567">10</option>
                      </select>
                    </div>}
                  {formData.isPregnant !== 'Yes' && <>
                      <div data-id="element-568">
                        <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-569">
                          Menopause? (रजोनिवृत्ति?)
                        </span>
                        <select id="isMenopause" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.isMenopause} onChange={handleChange} data-id="element-570">
                          <option value="" data-id="element-571">Select Option</option>
                          <option value="Yes" data-id="element-572">Yes (हां)</option>
                          <option value="No" data-id="element-573">No (नहीं)</option>
                        </select>
                      </div>
                      {formData.isMenopause !== 'Yes' && <>
                          <div data-id="element-574">
                            <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-575">
                              Mensturation Duration in Days (मासिक धर्म की अवधि
                              दिनों में)
                            </span>
                            <select id="mensturation" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.mensturation} onChange={handleChange} data-id="element-576">
                              <option value="" data-id="element-577">Select Option</option>
                              <option value="Comes before 16 days (16 दिनों से पहले आता है)" data-id="element-578">
                                Comes before 16 days (16 दिनों से पहले आता है)
                              </option>
                              <option value="Comes 16 days (16 दिनों में आता है)" data-id="element-579">
                                Comes 16 days (16 दिनों में आता है)
                              </option>
                              <option value="Comes 17 days (17 दिनों में आता है)" data-id="element-580">
                                Comes 17 days (17 दिनों में आता है)
                              </option>
                              <option value="Comes 18 days (18 दिनों में आता है)" data-id="element-581">
                                Comes 18 days (18 दिनों में आता है)
                              </option>
                              <option value="Comes 19 days (19 दिनों में आता है)" data-id="element-582">
                                Comes 19 days (19 दिनों में आता है)
                              </option>
                              <option value="Comes 20 days (20 दिनों में आता है)" data-id="element-583">
                                Comes 20 days (20 दिनों में आता है)
                              </option>
                              <option value="Comes 21 days (21 दिनों में आता है)" data-id="element-584">
                                Comes 21 days (21 दिनों में आता है)
                              </option>
                              <option value="Comes 22 days (22 दिनों में आता है)" data-id="element-585">
                                Comes 22 days (22 दिनों में आता है)
                              </option>
                              <option value="Comes 23 days (23 दिनों में आता है)" data-id="element-586">
                                Comes 23 days (23 दिनों में आता है)
                              </option>
                              <option value="Comes 24 days (24 दिनों में आता है)" data-id="element-587">
                                Comes 24 days (24 दिनों में आता है)
                              </option>
                              <option value="Comes 25 days (25 दिनों में आता है)" data-id="element-588">
                                Comes 25 days (25 दिनों में आता है)
                              </option>
                              <option value="Comes 26 days (26 दिनों में आता है)" data-id="element-589">
                                Comes 26 days (26 दिनों में आता है)
                              </option>
                              <option value="Comes 27 days (27 दिनों में आता है)" data-id="element-590">
                                Comes 27 days (27 दिनों में आता है)
                              </option>
                              <option value="Comes 28 days (28 दिनों में आता है)" data-id="element-591">
                                Comes 28 days (28 दिनों में आता है)
                              </option>
                              <option value="Comes 29 days (29 दिनों में आता है)" data-id="element-592">
                                Comes 29 days (29 दिनों में आता है)
                              </option>
                              <option value="Comes 30 days (30 दिनों में आता है)" data-id="element-593">
                                Comes 30 days (30 दिनों में आता है)
                              </option>
                              <option value="Comes 31 days (31 दिनों में आता है)" data-id="element-594">
                                Comes 31 days (31 दिनों में आता है)
                              </option>
                              <option value="More than 36 days (36 दिनों से अधिक)" data-id="element-595">
                                More than 36 days (36 दिनों से अधिक)
                              </option>
                            </select>
                          </div>
                          <div data-id="element-596">
                            <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-597">
                              Cycle days (चक्र दिवस)
                            </span>
                            <select id="cdays" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.cdays} onChange={handleChange} data-id="element-598">
                              <option value="" data-id="element-599">Select Option</option>
                              <option value="Does not comes without Medicine (दवा के बिना नहीं आता है)" data-id="element-600">
                                Does not comes without Medicine (दवा के बिना
                                नहीं आता है)
                              </option>
                              <option value="1 Day (1 दिन)" data-id="element-601">
                                1 Day (1 दिन)
                              </option>
                              <option value="2 Days (2 दिन)" data-id="element-602">
                                2 Days (2 दिन)
                              </option>
                              <option value="3 Days (3 दिन)" data-id="element-603">
                                3 Days (3 दिन)
                              </option>
                              <option value="4 Days (4 दिन)" data-id="element-604">
                                4 Days (4 दिन)
                              </option>
                              <option value="5 Days (5 दिन)" data-id="element-605">
                                5 Days (5 दिन)
                              </option>
                              <option value="6 Days (6 दिन)" data-id="element-606">
                                6 Days (6 दिन)
                              </option>
                              <option value="7 Days (7 दिन)" data-id="element-607">
                                7 Days (7 दिन)
                              </option>
                              <option value="More than 7 Days (7 दिनों से अधिक)" data-id="element-608">
                                More than 7 Days (7 दिनों से अधिक)
                              </option>
                              <option value="Does not stops without medicine (दवा के बिना रुकता नहीं है)" data-id="element-609">
                                Does not stops without medicine (दवा के बिना
                                रुकता नहीं है)
                              </option>
                            </select>
                          </div>
                          <div data-id="element-610">
                            <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-611">
                              Painful (दर्दनाक)
                            </span>
                            <div className="grid grid-cols-2 gap-2" data-id="element-612">
                              <label className="flex items-center space-x-2" data-id="element-613">
                                <input type="checkbox" name="noPain" checked={formData.painful.noPain} onChange={handlePainfulChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-614" />
                                <span className="text-sm" data-id="element-615">
                                  No Pain (कोई दर्द नहीं)
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-616">
                                <input type="checkbox" name="before" checked={formData.painful.before} onChange={handlePainfulChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-617" />
                                <span className="text-sm" data-id="element-618">Before (पहले)</span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-619">
                                <input type="checkbox" name="during" checked={formData.painful.during} onChange={handlePainfulChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-620" />
                                <span className="text-sm" data-id="element-621">During (दौरान)</span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-622">
                                <input type="checkbox" name="after" checked={formData.painful.after} onChange={handlePainfulChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-623" />
                                <span className="text-sm" data-id="element-624">After (बाद)</span>
                              </label>
                            </div>
                          </div>
                          <div data-id="element-625">
                            <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-626">
                              Clots (थक्के)
                            </span>
                            <select id="clots" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.clots} onChange={handleChange} data-id="element-627">
                              <option value="" data-id="element-628">Select Option</option>
                              <option value="Yes (हां)" data-id="element-629">Yes (हां)</option>
                              <option value="No (नहीं)" data-id="element-630">No (नहीं)</option>
                            </select>
                          </div>
                          <div data-id="element-631">
                            <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-632">
                              Type of Flow (प्रवाह का प्रकार)
                            </span>
                            <select id="flowType" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.flowType} onChange={handleChange} data-id="element-633">
                              <option value="" data-id="element-634">Select Flow Type</option>
                              <option value="Scanty (अल्प)" data-id="element-635">
                                Scanty (अल्प)
                              </option>
                              <option value="Normal (सामान्य)" data-id="element-636">
                                Normal (सामान्य)
                              </option>
                              <option value="Excess (अधिकता)" data-id="element-637">
                                Excess (अधिकता)
                              </option>
                            </select>
                          </div>
                          {/* Reproductive & Gynecological Conditions */}
                          <div data-id="element-638">
                            <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-639">
                              Reproductive & Gynecological Conditions
                            </span>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-640">
                              <label className="flex items-center space-x-2" data-id="element-641">
                                <input type="checkbox" name="none" checked={!Object.values(formData.gynecologicalConditions).some(value => value === true)} onChange={e => {
                        if (e.target.checked) {
                          // If None is checked, uncheck all other options
                          const resetGynConditions = {};
                          Object.keys(formData.gynecologicalConditions).forEach(key => {
                            resetGynConditions[key] = false;
                          });
                          setFormData(prev => ({
                            ...prev,
                            gynecologicalConditions: resetGynConditions
                          }));
                        }
                      }} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-642" />
                                <span className="text-sm font-medium" data-id="element-643">
                                  None
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-644">
                                <input type="checkbox" name="cancers" checked={formData.gynecologicalConditions.cancers} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-645" />
                                <span className="text-sm" data-id="element-646">
                                  Cancers: Breast cancer, ovarian cancer, and
                                  cervical cancer
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-647">
                                <input type="checkbox" name="endometriosis" checked={formData.gynecologicalConditions.endometriosis} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-648" />
                                <span className="text-sm" data-id="element-649">Endometriosis</span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-650">
                                <input type="checkbox" name="pcos" checked={formData.gynecologicalConditions.pcos} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-651" />
                                <span className="text-sm" data-id="element-652">
                                  Polycystic Ovary Syndrome (PCOS)
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-653">
                                <input type="checkbox" name="dysmenorrhea" checked={formData.gynecologicalConditions.dysmenorrhea} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-654" />
                                <span className="text-sm" data-id="element-655">
                                  Dysmenorrhea (cramps)
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-656">
                                <input type="checkbox" name="amenorrhea" checked={formData.gynecologicalConditions.amenorrhea} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-657" />
                                <span className="text-sm" data-id="element-658">
                                  Amenorrhea (absent periods)
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-659">
                                <input type="checkbox" name="menorrhagia" checked={formData.gynecologicalConditions.menorrhagia} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-660" />
                                <span className="text-sm" data-id="element-661">
                                  Menorrhagia (heavy bleeding)
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-662">
                                <input type="checkbox" name="pms" checked={formData.gynecologicalConditions.pms} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-663" />
                                <span className="text-sm" data-id="element-664">
                                  Premenstrual Syndrome (PMS)
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-665">
                                <input type="checkbox" name="adenomyosis" checked={formData.gynecologicalConditions.adenomyosis} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-666" />
                                <span className="text-sm" data-id="element-667">Adenomyosis</span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-668">
                                <input type="checkbox" name="utis" checked={formData.gynecologicalConditions.utis} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-669" />
                                <span className="text-sm" data-id="element-670">
                                  Urinary Tract Infections (UTIs)
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-671">
                                <input type="checkbox" name="anemia" checked={formData.gynecologicalConditions.anemia} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-672" />
                                <span className="text-sm" data-id="element-673">Anemia</span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-674">
                                <input type="checkbox" name="infertility" checked={formData.gynecologicalConditions.infertility} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-675" />
                                <span className="text-sm" data-id="element-676">Infertility</span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-677">
                                <input type="checkbox" name="fibroidsCysts" checked={formData.gynecologicalConditions.fibroidsCysts} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-678" />
                                <span className="text-sm" data-id="element-679">
                                  Fibroids / Cysts
                                </span>
                              </label>
                            </div>
                          </div>
                        </>}
                    </>}
                </div>
              </div>}
          </div>
          {/* Medical History */}
          <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-680">
            <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-681">
              Complaint & Illness Information
            </h3>
            <div className="grid grid-cols-1 gap-4" data-id="element-682">
              <div data-id="element-683">
                <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-684">
                  Chief / Main Complaint (मुख्य/मुख्य शिकायत)
                </span>
                <textarea id="ccomplaint" placeholder="Chief / Main Complaint" rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.ccomplaint} onChange={handleChange} data-id="element-685"></textarea>
              </div>
              <div data-id="element-686">
                <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-687">
                  Present Illness (वर्तमान बीमारी)
                </span>
                <textarea id="presentill" placeholder="Present Illness" rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.presentill} onChange={handleChange} data-id="element-688"></textarea>
              </div>
              <div data-id="element-689">
                <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-690">
                  Past Illness (पिछली बीमारी)
                </span>
                <textarea id="pastill" placeholder="Past Illness" rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.pastill} onChange={handleChange} data-id="element-691"></textarea>
              </div>
              <div data-id="element-692">
                <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-693">
                  Family History (पारिवारिक इतिहास)
                </span>
                <textarea id="fhistory" placeholder="Family History" rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.fhistory} onChange={handleChange} data-id="element-694"></textarea>
              </div>
            </div>
          </div>
          {/* File Upload Sections */}
          <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-695">
            <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-696">
              Tongue Images (जीभ की तस्वीरें)
            </h3>
            <p className="text-sm text-gray-600 mb-3" data-id="element-697">
              Upload tongue pictures without brushing (बिना ब्रश किए जीभ की
              तस्वीरें अपलोड करें) - Maximum 10 images
            </p>
            <div className="mb-3" data-id="element-698">
              <label className="flex items-center justify-center w-full px-4 py-6 bg-white border-2 border-dashed border-blue-300 rounded-lg cursor-pointer hover:border-blue-500 transition-colors" data-id="element-699">
                <div className="text-center" data-id="element-700">
                  <svg className="mx-auto h-12 w-12 text-blue-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" data-id="element-701">
                    <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-702" />
                  </svg>
                  <p className="mt-2 text-sm text-gray-600" data-id="element-703">
                    Click to upload tongue images
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-704">
                    PNG, JPG, JPEG (Max 10 files)
                  </p>
                </div>
                <input type="file" className="hidden" accept="image/*" multiple onChange={handleTongueImageUpload} data-id="element-705" />
              </label>
            </div>
            {tongueImages.length > 0 && <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-id="element-706">
                {tongueImages.map((img, index) => <div key={index} className="relative bg-white p-2 rounded-md border border-gray-200" data-id="element-707">
                    <img src={img.preview} alt={`Tongue ${index + 1}`} className="w-full h-24 object-cover rounded" data-id="element-708" />
                    <p className="text-xs text-gray-600 mt-1 truncate" data-id="element-709">
                      {img.name}
                    </p>
                    <button type="button" onClick={() => removeTongueImage(index)} className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 hover:bg-red-600" data-id="element-710">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-711">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-712" />
                      </svg>
                    </button>
                  </div>)}
              </div>}
          </div>

          {/* Report Files Upload */}
          <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-713">
            <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-714">
              Medical Reports (चिकित्सा रिपोर्ट)
            </h3>
            <p className="text-sm text-gray-600 mb-3" data-id="element-715">
              Upload medical reports, test results, prescriptions (चिकित्सा
              रिपोर्ट, परीक्षण परिणाम, नुस्खे अपलोड करें) - Maximum 10 files
            </p>
            <div className="mb-3" data-id="element-716">
              <label className="flex items-center justify-center w-full px-4 py-6 bg-white border-2 border-dashed border-blue-300 rounded-lg cursor-pointer hover:border-blue-500 transition-colors" data-id="element-717">
                <div className="text-center" data-id="element-718">
                  <svg className="mx-auto h-12 w-12 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-719">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" data-id="element-720" />
                  </svg>
                  <p className="mt-2 text-sm text-gray-600" data-id="element-721">
                    Click to upload reports
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-722">
                    PDF, PNG, JPG, JPEG (Max 10 files)
                  </p>
                </div>
                <input type="file" className="hidden" accept=".pdf,image/*" multiple onChange={handleReportFileUpload} data-id="element-723" />
              </label>
            </div>
            {reportFiles.length > 0 && <div className="space-y-2" data-id="element-724">
                {reportFiles.map((file, index) => <div key={index} className="flex items-center justify-between bg-white p-3 rounded-md border border-gray-200" data-id="element-725">
                    <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-726">
                      <svg className="w-8 h-8 text-blue-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-727">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" data-id="element-728" />
                      </svg>
                      <div className="flex-1 min-w-0" data-id="element-729">
                        <p className="text-sm font-medium text-gray-900 truncate" data-id="element-730">
                          {file.name}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-731">{file.size} MB</p>
                      </div>
                    </div>
                    <button type="button" onClick={() => removeReportFile(index)} className="ml-3 text-red-500 hover:text-red-700 flex-shrink-0" data-id="element-732">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-733">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" data-id="element-734" />
                      </svg>
                    </button>
                  </div>)}
              </div>}
          </div>

          {/* Consent checkbox */}
          <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-735">
            <div className="flex items-start" data-id="element-736">
              <div className="flex items-center h-5" data-id="element-737">
                <input id="terms" type="checkbox" checked={agreedToTerms} onChange={e => setAgreedToTerms(e.target.checked)} className="w-4 h-4 border border-gray-300 rounded text-blue-600 focus:ring-blue-500" required data-id="element-738" />
              </div>
              <div className="ml-3 text-sm" data-id="element-739">
                <label htmlFor="terms" className="font-medium text-gray-700" data-id="element-740">
                  I have read and I agree to the{' '}
                  <button type="button" onClick={() => setShowConsentPopup(true)} className="text-blue-600 hover:text-blue-800 underline focus:outline-none" data-id="element-741">
                    Informed Consent Form
                  </button>
                </label>
              </div>
            </div>
          </div>
          {/* Submit Section */}
          <div className="mt-6 text-center" data-id="element-742">
            <button type="submit" disabled={isGeneratingPDF} className="w-full sm:w-auto px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 mx-auto" data-id="element-743">
              {isGeneratingPDF ? <>
                  <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-744">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-745"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-746"></path>
                  </svg>
                  Generating PDF...
                </> : <>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-747">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" data-id="element-748" />
                  </svg>
                  Submit & Download PDF
                </>}
            </button>
          </div>
        </form>}
    </div>;
};